// @flow
import { Record, Map as IMap } from 'immutable';
import type { RecordFactory, RecordOf } from 'immutable';

export const REDUCER_KEY = 'datasetsStore';

type DatasetProps = {
  clientId: ?string,
  id: ?string,
  name: string,

  platform: ?string,
  subscriptionTier: ?string,
  createdByClientId: ?string,
  createdAt: ?string,
  lastSyncedAt: ?string,
  zipcode: string,

  disableRemoteAccess: boolean,
  isDeleted: ?boolean,
  platform: ?string,
}
export type Dataset = RecordOf<DatasetProps>;

export const makeDataset: RecordFactory<DatasetProps> =
  new Record({
    clientId: undefined,
    id: undefined,
    name: 'unnamed',

    platform: undefined,
    subscriptionTier: undefined,
    createdByClientId: undefined,
    createdAt: undefined,
    lastSyncedAt:  undefined,
    zipcode: '00000',

    disableRemoteAccess: false,
    isDeleted: false,
  });

type DatasetsStoreProps = {
  resourcesById: IMap<string, Dataset>,
  loadPending: boolean,
  isLoading: boolean,
  isUpserting: boolean,
  lastSyncDate: ?string,
  error: ?any,
}
export type DatasetsStore = RecordOf<DatasetsStoreProps>;

export const makeDatasetsStore: RecordFactory<DatasetsStoreProps> =
  new Record({
    resourcesById: new IMap(),
    loadPending: true,
    isLoading: false,
    isUpserting: false,
    lastSyncDate: null,
    error: undefined,
  });

export type getDatasetsPayload = {
  datasets: Array<Dataset>,
  replace: boolean,
  loadPending: boolean,
  isUpserting: boolean,
  lastSyncDate: string,
}
